// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__+fywu","vidWrapper":"Video_vidWrapper__EFrSM","inner":"Video_inner__6WVS-","chapters":"Video_chapters__-KnQq","active":"Video_active__XwhEF"};